import Reset from './page/Reset';
import AccessError from './page/AccessError';
import Login from './page/Login';
import Logout from './page/Logout';
import Help from './page/Help';
import QRLogin from './page/QRLogin';
import QRLoginError from './page/QRLogin/Error';
import QRLoginSuccess from './page/QRLogin/Success';

// 除cas基础功能外, 后续新增的页面请使用/cas/front/作为路由头, 避免频繁更改ngnix
export default [
    {
        title: '首页',
        path: '/cas/front/qrlogin',
        name: 'home',
        layout: 'QRLoginLayout',
        exact: false,
        subRoutes: [
            {
                title: '二维码登录确认',
                path: '/cas/front/qrlogin/confirm',
                name: 'qrloginConfirm',
                component: QRLogin,
            },
            {
                title: '二维码登录错误',
                path: '/cas/front/qrlogin/error',
                name: 'qrloginError',
                component: QRLoginError,
            },
            {
                title: '二维码登录成功',
                path: '/cas/front/qrlogin/success',
                name: 'qrloginSuccess',
                component: QRLoginSuccess,
            },
        ]
    },
    {
        title: '首页',
        path: '/cas',
        name: 'home',
        layout: 'BasicLayout',
        exact: false,
        subRoutes: [
            {
                title: '重置密码',
                path: '/cas/reset',
                name: 'reset',
                component: Reset,
            },
            {
                title: '拒绝访问',
                path: '/cas/accessError',
                name: 'accessError',
                component: AccessError,
            },
            {
                title: '登录',
                path: '/cas/login',
                name: 'login',
                component: Login,
            },
            {
                title: '注销',
                path: '/cas/logout',
                name: 'logout',
                component: Logout,
            },
            {
                title: '帮助',
                path: '/cas/help',
                name: 'help',
                component: Help,
            },
        ]
    },
    {
        path: '*',
        redirect: '/cas/login',
    }
];
